// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__22SK1","box":"WorkspacesBox_box__2861T","node":"WorkspacesBox_node__IcAKU"};